/**
 * PressBoxFamilyPreviewPage — 2026-10-22 (per Gilles). One game EXACTLY as
 * the families will see it, published or not. A draft carries a clear
 * banner; the coach previews, then publishes from the game page or the
 * Publish tab.
 */
import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../../services/api.js';
import { Frame, PublicGameBody } from '../public-stats/PublicStatsPage.jsx';

export default function PressBoxFamilyPreviewPage() {
  const { teamId, gameId } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get(`/teams/${teamId}/press-box/games/${gameId}/family-preview`)
      .then(({ data: d }) => { if (alive) setData(d); })
      .catch((e) => { if (alive) setData({ error: e.response?.data?.error || 'Could not build the preview' }); });
    return () => { alive = false; };
  }, [teamId, gameId]);
  if (!data) return <Frame team="…"><div style={{ color: 'var(--text-2)' }}>Building the preview…</div></Frame>;
  if (data.error) return <Frame team="Preview"><div className="card p-4 text-center">{data.error}</div></Frame>;
  return (
    <Frame team={data.team?.name} sub="Family-view preview">
      <div className="card mb-4 text-sm" style={{ border: `1px solid ${data.publishedAt ? 'var(--goal)' : 'var(--puck, #ff8a00)'}`, color: 'var(--text-2)' }} data-preview-banner>
        <strong style={{ color: data.publishedAt ? 'var(--goal)' : 'var(--puck, #ff8a00)' }}>
          {data.publishedAt ? 'PREVIEW — this game is published.' : 'PREVIEW — not published yet.'}
        </strong>{' '}
        This is exactly what families see from the shared link{data.publishedAt ? '' : ' once you publish it (awaiting your review and any fixes)'}.
        {' '}<Link to={`/press-box/${teamId}/game/${gameId}`} style={{ color: 'var(--ice)' }}>← Back to the game</Link>
        {' · '}<Link to={`/press-box/${teamId}/publish`} style={{ color: 'var(--ice)' }}>Publish tab</Link>
      </div>
      <PublicGameBody data={data} />
    </Frame>
  );
}
